/**
 * 사이트 공통 SEO 값. vite.config(정적 index.html·robots·sitemap)와 런타임 buildSeo 가 함께 읽는다.
 * vite.config 가 Node 에서 import 하므로 import.meta.env·브라우저 API·@platform/* 를 쓰면 안 된다.
 */

/** canonical 정본 호스트. 환경마다 달라지면 안 된다. */
export const SITE_URL = 'https://www.howcost.co.kr';

export const SITE_NAME = 'HOWCOST';

export const TITLE_TEMPLATE = '%s | (주)하우코스트 | HOWCOST';

/** JS 를 실행하지 않는 미리보기 봇이 모든 경로에서 보게 되는 값이라 홈과 같게 둔다. */
export const HOME_TITLE = 'HOWCOST: 스마트 건축 적산 선두기업';
export const HOME_DESCRIPTION =
  '건설의 모든 비용, 한 줄로 정렬되다. CAD·BIM 도면에서 적산까지. 3만 명의 건설인이 선택한 통합 견적 솔루션.';

/** public/og 기준. 봇은 상대경로를 못 읽으므로 쓰는 쪽에서 절대 URL 로 바꾼다. */
export const DEFAULT_OG_IMAGE = '/og/default.png';

/**
 * sitemap.xml 에 싣는 공개 경로. 로그인·결제·토큰 URL 은 넣지 않는다.
 * PATHS 를 import 하면 @platform/media 까지 끌려와 Node 에서 깨지므로 문자열로 둔다.
 */
export const SITEMAP_PATHS = [
  '/',
  '/about',
  '/store',
  '/products/xcost-pro',
  '/products/xpixels-aqc',
  '/products/xpixels-sqc',
  '/products/xpixels-eqc',
  '/products/xpixels-mqc',
  '/products/worknote',
  '/education',
  '/docs',
  '/pumsem',
  '/news/notices',
  '/news/updates',
  '/news/events',
  '/support/faqs',
  '/support/collaboration',
  '/legal/terms',
  '/legal/privacy',
  '/legal/refund',
] as const;
